import React, { memo } from 'react';
const FooterCopyrightNotice = ({
  text = `© Robert Bosch GmbH ${new Date().getFullYear()}, all rights reserved`
}) => /*#__PURE__*/React.createElement("span", {
  className: "ebds-footer__content__legal-row__copyright-notice"
}, text);
export default /*#__PURE__*/memo(FooterCopyrightNotice);